module.exports = __webpack_public_path__ + "img/ssb_logo2.78326cec.png";